const handleTagSearch = (fieldsConfig, field, value) => {
    const cfg = fieldsConfig[field]
    if (!cfg) return

    if (value && value.includes(',')) {
        const newValue = [...new Set([...cfg.oldValue, ...value.replace(/ /g, ',').split(',').map(i => i.trim()).filter(i => i)])]
        cfg.setFieldValue(newValue)
        cfg.setSearch('')
    } else {
        cfg.setSearch(value || '')
    }
}

export default handleTagSearch
